import { useEffect } from 'react';

export const useHeightObserver = (
  elementWithHeightRef: React.RefObject<HTMLElement>,
  backgroundElementRef: React.RefObject<HTMLElement>,
  onHeightChange: () => void,
) => {
  useEffect(() => {
    if (!elementWithHeightRef.current) {
      return;
    }
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      const height = entry.borderBoxSize[0].blockSize;
      if (backgroundElementRef.current) {
        // TODO: debug backgroundElementRef.current is null
        backgroundElementRef.current.style.height = `${height}px`;
        onHeightChange();
      }
    });

    observer.observe(elementWithHeightRef.current!);

    return () => {
      observer.disconnect();
    };
  }, []);
};
